import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "text-center flex items-center justify-center min-h-screen" }
const _hoisted_2 = { class: "md:w-96" }
const _hoisted_3 = { class: "mt-4 my-3 text-center" }
const _hoisted_4 = ["src"]
const _hoisted_5 = { class: "signup-form" }
const _hoisted_6 = {
  key: 0,
  class: "bg-dark-theme shadow"
}
const _hoisted_7 = /*#__PURE__*/_createElementVNode("h5", { class: "mb-4 text-white text-xl" }, "Change Password", -1)
const _hoisted_8 = { class: "form-group mb-3" }
const _hoisted_9 = { class: "input-group" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", { class: "input-group-prepend" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "input-group-text" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "xr-icon-lock text-red-primary opacity-75" })
  ])
], -1)
const _hoisted_11 = { class: "form-group mb-3" }
const _hoisted_12 = { class: "input-group" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("div", { class: "input-group-prepend" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "input-group-text" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "xr-icon-lock text-red-primary opacity-75" })
  ])
], -1)
const _hoisted_14 = { class: "form-group" }
const _hoisted_15 = {
  key: 1,
  class: "btn-primary-full"
}
const _hoisted_16 = /*#__PURE__*/_createElementVNode("p", { class: "mb-0 mt-3 text-gray-text text-md" }, "Already have an account?", -1)
const _hoisted_17 = { class: "flex items-center" }
const _hoisted_18 = /*#__PURE__*/_createTextVNode("Click here to login ")
const _hoisted_19 = { class: "inline-block ml-1" }
const _hoisted_20 = {
  key: 1,
  class: "bg-dark-theme shadow"
}
const _hoisted_21 = /*#__PURE__*/_createElementVNode("h5", { class: "mb-5 text-gray-text" }, "Password Change Successful!", -1)
const _hoisted_22 = /*#__PURE__*/_createElementVNode("span", {
  class: "xr-icon-check display-6 my-4 text-red-primary",
  style: {"font-size":"4em"}
}, null, -1)
const _hoisted_23 = /*#__PURE__*/_createElementVNode("p", { class: "my-4 text-gray-text" }, "You may now login with your new password", -1)
const _hoisted_24 = { class: "form-group" }
const _hoisted_25 = /*#__PURE__*/_createTextVNode("Login")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_authFooter = _resolveComponent("authFooter")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("img", {
          src: require('@/assets/images/MetaXar-Games.svg'),
          class: "w-52 inline-block"
        }, null, 8, _hoisted_4)
      ]),
      _createElementVNode("div", _hoisted_5, [
        (_ctx.activeSection == 'confirmPassword' || _ctx.activeSection == 'loadingConfirmPassword')
          ? (_openBlock(), _createElementBlock("form", _hoisted_6, [
              _hoisted_7,
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("div", _hoisted_9, [
                  _hoisted_10,
                  _withDirectives(_createElementVNode("input", {
                    type: "password",
                    autocomplete: "off",
                    class: "form-control",
                    name: "password",
                    placeholder: "Password",
                    required: "",
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.password) = $event))
                  }, null, 512), [
                    [_vModelText, _ctx.password]
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_11, [
                _createElementVNode("div", _hoisted_12, [
                  _hoisted_13,
                  _withDirectives(_createElementVNode("input", {
                    type: "password",
                    autocomplete: "off",
                    class: "form-control",
                    name: "Confirm Password",
                    placeholder: "Confirm Password",
                    required: "",
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.confirm) = $event))
                  }, null, 512), [
                    [_vModelText, _ctx.confirm]
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_14, [
                (_ctx.activeSection == 'confirmPassword')
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 0,
                      class: "btn-primary-full",
                      onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.changePassword && _ctx.changePassword(...args)))
                    }, "Submit"))
                  : _createCommentVNode("", true),
                (_ctx.activeSection == 'loadingConfirmPassword')
                  ? (_openBlock(), _createElementBlock("button", _hoisted_15, "Submitting..."))
                  : _createCommentVNode("", true)
              ]),
              _hoisted_16,
              _createVNode(_component_router_link, {
                to: { name: 'viewAuthLogin' },
                class: "text-red-primary text-md inline-block"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_17, [
                    _hoisted_18,
                    _createElementVNode("i", _hoisted_19, [
                      _createVNode(_component_font_awesome_icon, { icon: "fa-solid fa-long-arrow-right" })
                    ])
                  ])
                ]),
                _: 1
              }),
              _createVNode(_component_authFooter)
            ]))
          : _createCommentVNode("", true),
        (_ctx.activeSection == 'confirmPasswordSuccess')
          ? (_openBlock(), _createElementBlock("form", _hoisted_20, [
              _hoisted_21,
              _hoisted_22,
              _hoisted_23,
              _createElementVNode("div", _hoisted_24, [
                _createVNode(_component_router_link, {
                  to: "/",
                  class: "btn-primary-full",
                  style: {"font-size":"16px"}
                }, {
                  default: _withCtx(() => [
                    _hoisted_25
                  ]),
                  _: 1
                })
              ]),
              _createVNode(_component_authFooter)
            ]))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
}